import request from '@/utils/analyticsRequest'

export function getGhlStatus() {
  return request({ url: '/api/v1/crm/oauth/status', method: 'get' })
}

export function listGhlLocations() {
  return request({ url: '/api/v1/ghl/locations/mine', method: 'get' })
}

export function provisionGhlLocation(data) {
  return request({
    url: '/api/v1/ghl/locations/provision',
    method: 'post',
    data,
    timeout: 30000
  })
}

export function subscribeGhlPlan(data) {
  return request({
    url: '/api/v1/ghl/subscriptions/subscribe',
    method: 'post',
    data,
    timeout: 30000
  })
}

export function getCommentDmCustomValue() {
  return request({ url: '/api/v1/ghl/locations/custom-values/comment-dm', method: 'get' })
}

export function updateCommentDmCustomValue(value) {
  return request({
    url: '/api/v1/ghl/locations/custom-values/comment-dm',
    method: 'put',
    data: { value },
    headers: { 'Content-Type': 'application/json' }
  })
}

export function getAutoCommentCustomValues() {
  return request({ url: '/api/v1/ghl/locations/custom-values/auto-comments', method: 'get' })
}

export function updateAutoCommentCustomValues(values) {
  return request({
    url: '/api/v1/ghl/locations/custom-values/auto-comments',
    method: 'put',
    data: { values },
    headers: { 'Content-Type': 'application/json' }
  })
}
